<template>
  <div class="row mt-2">
    <div class="col-md-12 custom-wrapper">
      <z-table
        :value="media"
        sortBy="name"
        orderBy="asc"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
      >
        <template v-slot:tbody="props">
          <th scope="row">{{ props.row.name }}</th>
          <td class="z-column-140-center">
            {{ props.row.progressDate }}
          </td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
export default {
  name: 'component-list',
  components: {
    ZTable,
  },
  props: {
    componentName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('dashboardComponents', ['memberStatus']),
    tableColumns() {
      let columns = [
        {
          field: 'name',
          label: 'Media',
          sortable: false,
        },
        {
          field: 'progressDate',
          label: 'Viewed',
          sortable: false,
          class: 'z-column-140-center',
        },
      ]
      return columns
    },
    media() {
      let _data = []
      if (this.memberStatus) {
        this.memberStatus.forEach((element) => {
          if (element.componentName === this.componentName) {
            _data.push({
              componentName: element.componentName,
              name: element.name,
              progressDate: this.formatDate(element.progressDate),
            })
          }
        })
      }
      return _data
    },
  },
  methods: {
    formatDate(date) {
      let _date = null
      if (date) {
        _date = moment(new Date(date)).format('MM/DD/YYYY')
      }
      return _date
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 300px;
  width: 100%;
}
</style>
